export default Object.freeze([{text: '支出', value: 'expense'},
  {text: '收入', value: 'income'}]);